import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import galleryData from '../../../galleryData.json';
import ImageViewer from '../ImageViewer';

import go from 'assets/windowsIcons/290.png';
import search from 'assets/windowsIcons/299(32x32).png';
import back from 'assets/windowsIcons/back.png';
import forward from 'assets/windowsIcons/forward.png';
import up from 'assets/windowsIcons/up.png';
import folderOpen from 'assets/windowsIcons/337(32x32).png';
import folderSmall from 'assets/windowsIcons/318(16x16).png';
import documentSmall from 'assets/windowsIcons/308(16x16).png';
import networkSmall from 'assets/windowsIcons/693(16x16).png';
import menu from 'assets/windowsIcons/358(32x32).png';
import dropdown from 'assets/windowsIcons/dropdown.png';
import pullup from 'assets/windowsIcons/pullup.png';
import windows from 'assets/windowsIcons/windows.png';
import folderIcon from 'assets/windowsIcons/folder.png';

const viewerIcon = '/my-art/Ditto.png';

function ImageFolder({ folderKey, title }) {
  const [images, setImages] = useState(() => galleryData[folderKey] || []);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;

    function loadGallery() {
      const query = `gallery=${encodeURIComponent(folderKey)}&_=${Date.now()}`;
      fetch(`/gallery-index.php?${query}`, { cache: 'no-store' })
        .then(response => {
          if (!response.ok) throw new Error('Unable to load gallery');
          return response.json();
        })
        .then(data => {
          if (cancelled || !data || !Array.isArray(data.images)) return;
          setImages(data.images);
        })
        .catch(() => {
          if (!cancelled) setImages(galleryData[folderKey] || []);
        })
        .finally(() => {
          if (!cancelled) setLoading(false);
        });
    }

    loadGallery();
    function onContentRefresh(event) {
      if (event.detail === title) loadGallery();
    }
    window.addEventListener('focus', loadGallery);
    window.addEventListener('lottel:content-refresh', onContentRefresh);
    return () => {
      cancelled = true;
      window.removeEventListener('focus', loadGallery);
      window.removeEventListener('lottel:content-refresh', onContentRefresh);
    };
  }, [folderKey, title]);

  function openImage(index, filename) {
    const appSettings = {
      header: {
        icon: viewerIcon,
        title: filename + ' - Windows Picture and Fax Viewer',
      },
      component: ImageViewer,
      injectProps: { images, initialIndex: index },
      defaultSize: { width: 600, height: 450 },
      defaultOffset: { x: 250, y: 120 },
      resizable: true,
      minimized: false,
      maximized: false,
      multiInstance: true,
      id: 'viewer_' + Date.now(),
    };
    window.dispatchEvent(
      new CustomEvent('lottel:dynamic', { detail: appSettings }),
    );
  }

  // Otherwise show the standard XP Folder UI
  return (
    <Div>
      <section className="com__toolbar">
        <div className="com__options"></div>
        <img className="com__windows-logo" src={windows} alt="windows" />
      </section>

      <section className="com__function_bar">
        <div className="com__function_bar__button--disable">
          <img className="com__function_bar__icon" src={back} alt="" />
          <span className="com__function_bar__text">Back</span>
          <div className="com__function_bar__arrow" />
        </div>
        <div className="com__function_bar__button--disable">
          <img className="com__function_bar__icon" src={forward} alt="" />
          <div className="com__function_bar__arrow" />
        </div>
        <div className="com__function_bar__button--disable">
          <img className="com__function_bar__icon--normalize" src={up} alt="" />
        </div>
        <div className="com__function_bar__separate" />
        <div className="com__function_bar__button">
          <img
            className="com__function_bar__icon--normalize"
            src={search}
            alt=""
          />
          <span className="com__function_bar__text">Search</span>
        </div>
        <div className="com__function_bar__button">
          <img
            className="com__function_bar__icon--normalize"
            src={folderOpen}
            alt=""
          />
          <span className="com__function_bar__text">Folders</span>
        </div>
        <div className="com__function_bar__separate" />
        <div className="com__function_bar__button">
          <img
            className="com__function_bar__icon--margin12"
            src={menu}
            alt=""
          />
          <div className="com__function_bar__arrow" />
        </div>
      </section>

      <section className="com__address_bar">
        <div className="com__address_bar__title">Address</div>
        <div className="com__address_bar__content">
          <img
            src={folderIcon}
            alt="folder"
            className="com__address_bar__content__img"
          />
          <div className="com__address_bar__content__text">C:\{title}</div>
          <img
            src={dropdown}
            alt="dropdown"
            className="com__address_bar__content__img"
          />
        </div>
        <div className="com__address_bar__go">
          <img className="com__address_bar__go__img" src={go} alt="go" />
          <span className="com__address_bar__go__text">Go</span>
        </div>
      </section>

      <div className="com__content">
        <div className="com__content__inner">
          <div className="com__content__left">
            <div className="com__content__left__card">
              <div className="com__content__left__card__header">
                <div className="com__content__left__card__header__text">
                  Picture Tasks
                </div>
                <img
                  src={pullup}
                  alt=""
                  className="com__content__left__card__header__img"
                />
              </div>
              <div className="com__content__left__card__content">
                <div className="com__content__left__card__row">
                  <div className="com__content__left__card__text link">
                    View as a slide show
                  </div>
                </div>
                <div className="com__content__left__card__row">
                  <div className="com__content__left__card__text link">
                    Order prints online
                  </div>
                </div>
                <div className="com__content__left__card__row">
                  <div className="com__content__left__card__text link">
                    Print pictures
                  </div>
                </div>
              </div>
            </div>

            <div className="com__content__left__card">
              <div className="com__content__left__card__header">
                <div className="com__content__left__card__header__text">
                  File and Folder Tasks
                </div>
                <img
                  src={pullup}
                  alt=""
                  className="com__content__left__card__header__img"
                />
              </div>
              <div className="com__content__left__card__content">
                <div className="com__content__left__card__row">
                  <img
                    className="com__content__left__card__img"
                    src={folderSmall}
                    alt=""
                  />
                  <div className="com__content__left__card__text link">
                    Make a new folder
                  </div>
                </div>
                <div className="com__content__left__card__row">
                  <img
                    className="com__content__left__card__img"
                    src={networkSmall}
                    alt=""
                  />
                  <div className="com__content__left__card__text link">
                    Publish this folder to the Web
                  </div>
                </div>
                <div className="com__content__left__card__row">
                  <img
                    className="com__content__left__card__img"
                    src={documentSmall}
                    alt=""
                  />
                  <div className="com__content__left__card__text link">
                    Share this folder
                  </div>
                </div>
              </div>
            </div>

            <div className="com__content__left__card">
              <div className="com__content__left__card__header">
                <div className="com__content__left__card__header__text">
                  Details
                </div>
                <img
                  src={pullup}
                  alt=""
                  className="com__content__left__card__header__img"
                />
              </div>
              <div className="com__content__left__card__content">
                <div className="com__content__left__card__row">
                  <div className="com__content__left__card__text bold black">
                    {title}
                  </div>
                </div>
                <div className="com__content__left__card__row">
                  <div className="com__content__left__card__text black">
                    File Folder
                  </div>
                </div>
                <div className="com__content__left__card__row">
                  <div className="com__content__left__card__text black">
                    {images.length} objects
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="com__content__right">
            {!loading && images.length === 0 && (
              <div style={{ padding: '20px', color: '#666' }}>
                This folder is empty.
              </div>
            )}
            {images.length > 0 && (
              <div className="com__content__right__card">
                <div className="com__content__right__card__header">Files</div>
                <div className="com__content__right__card__content">
                  {images.map((srcUrl, index) => {
                    const filename = decodeURIComponent(srcUrl.split('/').pop());
                    return (
                      <div
                        className="com__content__right__card__item"
                        key={srcUrl}
                        onDoubleClick={() => openImage(index, filename)}
                        title={filename}
                      >
                        <div className="thumbnail-frame">
                          <img
                            src={srcUrl}
                            alt={filename}
                            className="thumbnail-img"
                          />
                        </div>
                        <div className="com__content__right__card__img-container">
                          <div className="com__content__right__card__text">
                            {filename}
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </Div>
  );
}

const ViewerContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  background-color: #eef3fa;

  .viewer-toolbar {
    height: 36px;
    background: linear-gradient(to right, #edede5 0%, #ede8cd 100%);
    border-bottom: 1px solid rgba(0, 0, 0, 0.2);
    display: flex;
    align-items: center;
    padding: 0 4px;
  }
  .viewer-btn {
    display: flex;
    align-items: center;
    background: transparent;
    border: 1px solid transparent;
    border-radius: 3px;
    padding: 4px 8px;
    font-size: 11px;
    cursor: pointer;
    img {
      height: 20px;
      margin-right: 4px;
    }
    &:hover {
      border: 1px solid rgba(0, 0, 0, 0.1);
      box-shadow: inset 0 -1px 1px rgba(0, 0, 0, 0.1);
    }
  }
  .viewer-content {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 10px;
    overflow: auto;
  }
  .viewer-img {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
    box-shadow: 2px 2px 8px rgba(0, 0, 0, 0.3);
  }
`;

const Div = styled.div`
  height: 100%;
  width: 100%;
  position: absolute;
  display: flex;
  overflow: hidden;
  flex-direction: column;
  background: linear-gradient(to right, #edede5 0%, #ede8cd 100%);

  .com__toolbar {
    position: relative;
    display: flex;
    align-items: center;
    line-height: 100%;
    height: 24px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.7);
    flex-shrink: 0;
  }
  .com__options {
    height: 23px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    border-right: 1px solid rgba(0, 0, 0, 0.1);
    padding: 1px 0 1px 2px;
    border-left: 0;
    flex: 1;
  }
  .com__windows-logo {
    height: 100%;
    border-left: 1px solid white;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  }
  .com__function_bar {
    height: 36px;
    display: flex;
    align-items: center;
    font-size: 11px;
    padding: 1px 3px 0;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    flex-shrink: 0;
  }
  .com__function_bar__button {
    display: flex;
    height: 100%;
    align-items: center;
    border: 1px solid rgba(0, 0, 0, 0);
    border-radius: 3px;
    &:hover {
      border: 1px solid rgba(0, 0, 0, 0.1);
      box-shadow: inset 0 -1px 1px rgba(0, 0, 0, 0.1);
    }
    &:hover:active {
      border: 1px solid rgb(185, 185, 185);
      background-color: #dedede;
      box-shadow: inset 0 -1px 1px rgba(255, 255, 255, 0.7);
      color: rgba(255, 255, 255, 0.7);
      & > * {
        transform: translate(1px, 1px);
      }
    }
  }
  .com__function_bar__button--disable {
    filter: grayscale(1);
    opacity: 0.7;
    display: flex;
    height: 100%;
    align-items: center;
    border: 1px solid rgba(0, 0, 0, 0);
  }
  .com__function_bar__text {
    margin-right: 4px;
  }
  .com__function_bar__icon {
    height: 30px;
    width: 30px;
    &--normalize {
      height: 22px;
      width: 22px;
      margin: 0 4px 0 1px;
    }
    &--margin12 {
      height: 22px;
      width: 22px;
      margin: 0 1px 0 2px;
    }
  }
  .com__function_bar__separate {
    height: 90%;
    width: 1px;
    background-color: rgba(0, 0, 0, 0.2);
    margin: 0 2px;
  }
  .com__function_bar__arrow {
    height: 100%;
    display: flex;
    align-items: center;
    margin: 0 4px;
    &:before {
      content: '';
      display: block;
      border-width: 3px 3px 0;
      border-color: #000 transparent;
      border-style: solid;
    }
  }
  .com__address_bar {
    flex-shrink: 0;
    border-top: 1px solid rgba(255, 255, 255, 0.7);
    height: 20px;
    font-size: 11px;
    display: flex;
    align-items: center;
    padding: 0 2px;
    box-shadow: inset 0 -2px 3px -1px #b0b0b0;
  }
  .com__address_bar__title {
    line-height: 100%;
    color: rgba(0, 0, 0, 0.5);
    padding: 5px;
  }
  .com__address_bar__content {
    border: rgba(122, 122, 255, 0.6) 1px solid;
    height: 100%;
    display: flex;
    flex: 1;
    align-items: center;
    background-color: white;
    position: relative;
    &__img {
      width: 14px;
      height: 14px;
    }
    &__img:last-child {
      width: 15px;
      height: 15px;
      right: 1px;
      position: absolute;
    }
    &__img:last-child:hover {
      filter: brightness(1.1);
    }
    &__text {
      white-space: nowrap;
      position: absolute;
      left: 16px;
      right: 17px;
    }
  }
  .com__address_bar__go {
    display: flex;
    align-items: center;
    padding: 0 18px 0 5px;
    height: 100%;
    position: relative;
    &__img {
      height: 95%;
      border: 1px solid rgba(255, 255, 255, 0.2);
      margin-right: 3px;
    }
  }

  .com__content {
    flex: 1;
    border: 1px solid rgba(0, 0, 0, 0.4);
    border-top-width: 0;
    background-color: #f1f1f1;
    overflow: auto;
    font-size: 11px;
    position: relative;
  }
  .com__content__inner {
    display: flex;
    height: 100%;
    overflow: auto;
  }
  .com__content__left {
    width: 180px;
    height: 100%;
    background: linear-gradient(to bottom, #748aff 0%, #4057d3 100%);
    overflow: auto;
    padding: 10px;
    flex-shrink: 0;
  }
  .com__content__left__card {
    border-top-left-radius: 3px;
    border-top-right-radius: 3px;
    width: 100%;
    overflow: hidden;
  }
  .com__content__left__card:not(:last-child) {
    margin-bottom: 12px;
  }
  .com__content__left__card__header {
    display: flex;
    align-items: center;
    height: 23px;
    padding-left: 11px;
    padding-right: 2px;
    cursor: pointer;
    background: linear-gradient(
      to right,
      rgb(240, 240, 255) 0,
      rgb(240, 240, 255) 30%,
      rgb(168, 188, 255) 100%
    );
  }
  .com__content__left__card__header:hover {
    & .com__content__left__card__header__text {
      color: #1c68ff;
    }
  }
  .com__content__left__card__header__text {
    font-weight: 700;
    color: #0c327d;
    flex: 1;
  }
  .com__content__left__card__header__img {
    width: 18px;
    height: 18px;
    filter: drop-shadow(1px 1px 3px rgba(0, 0, 0, 0.3));
  }
  .com__content__left__card__content {
    padding: 5px 10px;
    background: linear-gradient(
      to right,
      rgb(180, 200, 251) 0%,
      rgb(164, 185, 251) 50%,
      rgb(180, 200, 251) 100%
    );
    background-color: rgba(198, 211, 255, 0.87);
  }
  .com__content__left__card__row {
    display: flex;
    margin-bottom: 2px;
  }
  .com__content__left__card__img {
    width: 14px;
    height: 14px;
    margin-right: 5px;
  }
  .com__content__left__card__text {
    font-size: 10px;
    line-height: 14px;
    color: #0c327d;
    &.black {
      color: #000;
    }
    &.bold {
      font-weight: bold;
    }
    &.link:hover {
      cursor: pointer;
      color: #2b72ff;
      text-decoration: underline;
    }
  }

  .com__content__right {
    height: 100%;
    overflow: auto;
    background-color: #fff;
    flex: 1;
  }
  .com__content__right__card__header {
    width: 300px;
    font-weight: 700;
    padding: 2px 0 3px 12px;
    position: relative;
    &:after {
      content: '';
      display: block;
      background: linear-gradient(to right, #70bfff 0, #fff 100%);
      position: absolute;
      bottom: 0;
      left: -12px;
      height: 1px;
      width: 100%;
    }
  }
  .com__content__right__card__content {
    display: flex;
    align-items: center;
    padding-right: 0;
    flex-wrap: wrap;
    padding: 15px 15px 0;
  }
  .com__content__right__card__item {
    display: flex;
    align-items: center;
    width: 200px;
    margin-bottom: 15px;
    min-height: 56px;
    cursor: pointer;
    padding: 2px;
    border: 1px solid transparent;
    border-radius: 3px;
    &:hover {
      background: #e5efff;
      border-color: #b0c8e8;
    }
  }
  .thumbnail-frame {
    width: 45px;
    height: 45px;
    margin-right: 5px;
    flex-shrink: 0;
    border: 1px solid #a09f88;
    background: #f7f6ef;
    padding: 2px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .thumbnail-img {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
  }
  .com__content__right__card__text {
    white-space: pre-wrap;
    word-break: break-all;
    height: auto;
  }
`;

export default ImageFolder;
